// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__13GGP","tab":"Tabs_tab__3l_aE","tabActive":"Tabs_tabActive__3vgwF"};